import React from 'react';
import { Modal, ModalHeader } from 'reactstrap';
import WaterRightDocumentForm from '../Forms/WaterRightDocumentForm';

const AddWaterRightDocumentModal = ({ 
	isOpen, 
	handleToggleModal, 
	waterRightData,
	dataToEdit 
}) => {
	const isEditMode = !!dataToEdit;

	return (
		<Modal
			isOpen={isOpen}
			toggle={handleToggleModal}
			size='lg'
			className='border-0'
			modalClassName='modal fade zoomIn'
			backdrop='static'
			centered={true}
		>
			<ModalHeader toggle={handleToggleModal}>
				{isEditMode 
					? 'Editar documento asociado' 
					: 'Cargar nuevo documento asociado'}
			</ModalHeader>
			<WaterRightDocumentForm
				waterRightData={waterRightData}
				dataToEdit={dataToEdit}
				isOpen={isOpen}
				handleToggleModal={handleToggleModal}
			/>
		</Modal>
	);
};

export default AddWaterRightDocumentModal;
